import React, { useRef, useState } from "react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Upload, Loader2 } from "lucide-react";
import { toast } from "sonner";

const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const UploadField = ({ onUploaded, accept = "image/*", label = "Enviar", testid }) => {
  const ref = useRef(null);
  const [loading, setLoading] = useState(false);

  const handle = async (files) => {
    const file = files?.[0];
    if (!file) return;
    setLoading(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const res = await api.post("/upload", fd);
      onUploaded(`${BACKEND}${res.data.url}`, file.name);
      toast.success("Arquivo enviado!");
    } catch (e) {
      toast.error(e.response?.status === 413 ? "Arquivo grande demais (máx. 200 MB)." : "Falha ao enviar arquivo.");
    } finally {
      setLoading(false);
      if (ref.current) ref.current.value = "";
    }
  };

  // também aceita arrastar o arquivo da pasta e soltar no botão
  const [over, setOver] = useState(false);
  return (
    <>
      <input ref={ref} type="file" accept={accept || undefined} className="hidden" data-testid={testid} onChange={(e) => handle(e.target.files)} />
      <Button type="button" variant="outline" onClick={() => ref.current?.click()} disabled={loading}
        onDragOver={(e) => { e.preventDefault(); setOver(true); }} onDragLeave={() => setOver(false)}
        onDrop={(e) => { e.preventDefault(); setOver(false); handle(e.dataTransfer.files); }}
        className={`shrink-0 ${over ? "border-[#1E9E2A] bg-green-50" : ""}`} title="Clique ou arraste o arquivo até aqui">
        {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : <><Upload className="h-4 w-4 mr-1.5" /> {over ? "Solte aqui" : label}</>}
      </Button>
    </>
  );
};
